import { useMemo } from 'react';

import {
  GetSuggestedRecipientsResponse,
  SuggestedRecipientEmail,
} from 'lib/api/scheduling/getSuggestedRecipients';
import { StopTypes } from 'types/Appointment';
import { Maybe } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

export type SuggestedSchedulingRecipientsFetchResult = {
  emails: SuggestedRecipientEmail[];
  isLoading: boolean;
};

export default function useFetchSuggestedSchedulingRecipients(
  loadID?: Maybe<number>,
  stopType?: StopTypes
): SuggestedSchedulingRecipientsFetchResult {
  const endpoint = useMemo(() => {
    if (!loadID || !stopType) return null;
    return `scheduling/email/suggested-recipients?loadID=${loadID}&stopType=${stopType}`;
  }, [loadID, stopType]);

  const { data, isLoading } = useThrowableSWR<GetSuggestedRecipientsResponse>(
    endpoint,
    false
  );

  return {
    emails: data?.emails ?? [],
    isLoading,
  };
}
